/**
 * Swap in the build that is waiting, then load the page again from it.
 *
 * The plugin's own `updateServiceWorker` only reloads when the page's worker changes, and that
 * never happens on a page that opened with no worker in control (a hard reload, the first visit
 * before a deploy): the waiting worker took over, the page stayed, and so did the notice. Watching
 * the waiting worker itself reloads the page once it is active, whatever controlled the page.
 */
export async function reloadIntoUpdate(
  skipWaiting: () => Promise<void>,
  reload: () => void = () => window.location.reload(),
) {
  const waiting = (await navigator.serviceWorker.getRegistration())?.waiting
  if (!waiting) {
    // Another tab already swapped it in: this page only needs loading again.
    reload()
    return
  }
  waiting.addEventListener('statechange', () => {
    if (waiting.state === 'activated') reload()
  })
  await skipWaiting()
}
